// src/components/Farms/Staking/config.js

// eslint-disable-next-line import/no-unused-modules
export const STAKER_ADDRESS = '0x20fE27a5A1646143A40064C0809d1d41Ff5B6E3B'
export const POSITION_ADDRESS = '0x2DbA23C15A293943B372B553913eab8CD99db9F8'
